import EventSetting from './EventSetting'
export default EventSetting